"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiversAndSeas$ = exports.RiversAndSeas$outboundSchema = exports.RiversAndSeas$inboundSchema = void 0;
exports.riversAndSeasToJSON = riversAndSeasToJSON;
exports.riversAndSeasFromJSON = riversAndSeasFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const meta_js_1 = require("./meta.js");
const risk_js_1 = require("./risk.js");
const risksuitability_js_1 = require("./risksuitability.js");
/** @internal */
exports.RiversAndSeas$inboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    risk: risk_js_1.Risk$inboundSchema,
    risk_interpretation: z.string(),
    risk_suitability: z.nullable(risksuitability_js_1.RiskSuitability$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "risk_interpretation": "riskInterpretation",
        "risk_suitability": "riskSuitability",
    });
});
/** @internal */
exports.RiversAndSeas$outboundSchema = z.object({
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    risk: risk_js_1.Risk$outboundSchema,
    riskInterpretation: z.string(),
    riskSuitability: z.nullable(risksuitability_js_1.RiskSuitability$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        riskInterpretation: "risk_interpretation",
        riskSuitability: "risk_suitability",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RiversAndSeas$;
(function (RiversAndSeas$) {
    /** @deprecated use `RiversAndSeas$inboundSchema` instead. */
    RiversAndSeas$.inboundSchema = exports.RiversAndSeas$inboundSchema;
    /** @deprecated use `RiversAndSeas$outboundSchema` instead. */
    RiversAndSeas$.outboundSchema = exports.RiversAndSeas$outboundSchema;
})(RiversAndSeas$ || (exports.RiversAndSeas$ = RiversAndSeas$ = {}));
function riversAndSeasToJSON(riversAndSeas) {
    return JSON.stringify(exports.RiversAndSeas$outboundSchema.parse(riversAndSeas));
}
function riversAndSeasFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RiversAndSeas$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RiversAndSeas' from JSON`);
}
//# sourceMappingURL=riversandseas.js.map